import { businessPlanAxios } from 'services/controllers/businessPlan';

import * as t from './types';

export const BusinessPlanApi = {
  getAllBusinessPlans: async () => {
    const { data } = await businessPlanAxios.get<t.IAllBusinessPlansResponse>('');
    return data;
  },

  getBusinessPlan: async (id: string) => {
    const { data } = await businessPlanAxios.get<t.IBusinessPlanResponse>(`/${id}`);
    return data;
  },

  createBusinessPlan: async (body: t.ICreateBusinessPlanBody) => {
    const newBody = { ...body, metadata: JSON.stringify(body.metadata) };
    const { data } = await businessPlanAxios.post<t.ICreateBusinessPlanBodyResponse>('', newBody);
    return data;
  },
  createBusinessPlanFrom: async ({ businessPlanUuid, businessPlanType }: t.ICreateBusinessPlanFromOnePage) => {
    const { data } = await businessPlanAxios.post<t.ICreateBusinessPlanBodyResponse>(
      `/createFrom/${businessPlanUuid}/${businessPlanType}`,
      {},
    );
    return data;
  },

  updateBusinessPlan: async ({ id, body }: t.IUpdateBusinessPlanParams) => {
    const { data } = await businessPlanAxios.patch<t.IUpdateBusinessPlanBodyResponse>(`/${id}`, body);
    return data;
  },

  getLimits: async () => {
    const { data } = await businessPlanAxios.get<t.IGetLimitsResponse>('/limits');
    return data;
  },

  deleteBusinessPlan: async (id: string): Promise<void> => {
    await businessPlanAxios.delete(`/${id}`);
  },

  duplicateBusinessPlan: async (id: string) => {
    const { data } = await businessPlanAxios.post<t.IDuplicateBusinessPlanResponse>(`/${id}/duplicate`);
    return data;
  },

  grantEditAccess: async ({ id, body }: t.IGrantEditAccessParams) => {
    const { data } = await businessPlanAxios.post<t.IGrantEditAccessResponse>(`/${id}/permissions`, body);
    return data;
  },

  getUsersWithAccess: async ({ id, type = t.PLAN_ACCESS_TYPE.EDIT }: t.IGetUsersWithAccessParams) => {
    const { data } = await businessPlanAxios.get<t.IGetUsersWithAccessResponse>(
      `/${id}/permissions?permissionType=${type}`,
    );
    return data;
  },

  deleteUserAccess: async ({ id, email }: t.IDeleteUserAccessParams) => {
    await businessPlanAxios.delete(`/${id}/permissions/${email}`);
  },

  getIndustryPictutes: async ({ type }: t.IGetIndustryPictutesParams) => {
    const { data } = await businessPlanAxios.get<t.IIndustruPictureItem[]>(`/industry/images?industryType=${type}`);
    return data;
  },

  shareOnePageLinkByMail: async ({ id, email }: t.IShareOnePageByMailBody) => {
    const { data } = await businessPlanAxios.post<string>(`/${id}/shareLink?email=${email}`);
    return data;
  },

  getLinkPublicStatus: async ({ id }: t.IGetPublicStatusParams) => {
    const { data } = await businessPlanAxios.get<t.IGetPublicStatusResponse>(`/${id}/publicStatus`);
    return data;
  },

  changeOnePagePublicStatus: async ({ id, action }: t.IPatchPublicStatusParams) => {
    const { data } = await businessPlanAxios.patch<string>(`/${id}/share/${action}`);
    return data;
  },

  getPublicOnePagePlan: async ({ id }: t.IGetPublicOnePagePlanParams) => {
    const { data } = await businessPlanAxios.get<t.IGetPublicOnePagePlanResponse>(`/${id}/share/plan/`);
    return data;
  },

  getBusinessPlanPDFBinary: async (id: string) => {
    const { data } = await businessPlanAxios.get<Blob>(`/public/${id}/share/pdf`, { responseType: 'blob' });
    return data;
  },
};
